export default function DOM_ChangeNodes() {
  return (
    <div>
      <h1>DOM_ChangeNodes</h1>
      <p>This is the DOM_ChangeNodes component.</p>
    </div>
  );
}